function getReservationState(state) {
  return {
    isLoading: state.reservation.loading,
    fetchResponse: state.reservation.data,
    recievedSuccessfulResponse: state.reservation.recievedSuccessfulResponse,
    recievedErrorResponse: state.reservation.recievedErrorResponse,
    currentPosting: state.reservation.currentPosting
  };
}

export { getReservationState };
